import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthResolver {

  public isTokenExpired(token: string | null): boolean{
    if (!token || token === '') return true;
    const date = this.getTokenExpirationDate(token);

    if (date === null) return false;
    return !(<number>date.valueOf() > new Date().valueOf() + 0 * 1000);
  }

  protected getTokenExpirationDate(token: string | null): Date | null{
    const decoded: any = this.decodeToken(token);  
    if (!decoded || !decoded.hasOwnProperty('exp')) return null;
    
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);

    return date;
  }

  protected decodeToken(token: string | null): string | null{
    if (!token || token === '') return null;

    const parts = token.split('.');
    if (parts.length !== 3) throw new Error(`The inspected token doesn't appear to be a JWT. Check to make sure it has three parts and see https://jwt.io for more.`);

    const decoded = this.urlBase64Decode(parts[1]);
    if (!decoded) throw new Error('Cannot decode the token.');

    return JSON.parse(decoded);
  }

  protected urlBase64Decode(str: string): string{
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0:
        break;
        
      case 2: 
        output += '==';
        break;

      case 3:
        output += '=';
        break;

      default: 
        throw new Error('Illegal base64url string!');
    }
    return this.b64DecodeUnicode(output);
  }

  protected b64DecodeUnicode(str: string): string{
    return decodeURIComponent(Array.prototype.map.call(this.b64decode(str), (c: any) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
  }

  protected b64decode(str: string): string{
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output = '';

    str = String(str).replace(/=+$/, '');
    if (str.length % 4 === 1) throw new Error(`'atob' failed: The string to be decoded is not correctly encoded.`);

    for (
      let bc = 0, bs: any, buffer: any, idx = 0;
      (buffer = str.charAt(idx++));
      
      ~buffer && ((bs = bc % 4? bs * 64 + buffer : buffer), bc++ % 4)? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6)))) : 0
    ) buffer = chars.indexOf(buffer);

    return output;
  }
}
